module.exports = __webpack_public_path__ + "img/img-error02.c06b7502.png";